import { render, staticRenderFns } from "./OtpOrder.html?vue&type=template&id=f8a1aab2&scoped=true&"
import script from "./OtpOrder.js?vue&type=script&lang=js&"
export * from "./OtpOrder.js?vue&type=script&lang=js&"
import style0 from "./OtpOrder.scss?vue&type=style&index=0&id=f8a1aab2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a1aab2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
